module.exports = __webpack_public_path__ + "img/图.2c8d84df.webp";